import React, { useState, useEffect } from "react";

const TypingTest = () => {
  const TEST_DURATION = 120;

  const [timeLeft, setTimeLeft] = useState(TEST_DURATION);
  const [isActive, setIsActive] = useState(false);
  const [text, setText] = useState("");
  const [wordCount, setWordCount] = useState(0);
  const [wpm, setWpm] = useState(0);

  // Start Test
  const startTimer = () => {
    if (isActive) return;

    setText("");
    setTimeLeft(TEST_DURATION);
    setIsActive(true);
  };

  // Reset Test
  const resetTest = () => {
    setIsActive(false);
    setTimeLeft(TEST_DURATION);
    setText("");
    setWordCount(0);
    setWpm(0);
  };

  // Timer Logic
  useEffect(() => {
    if (!isActive) return;

    if (timeLeft === 0) {
      setIsActive(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, isActive]);

  // Word Count + WPM
  useEffect(() => {
    const words = text.trim().split(/\s+/).filter(Boolean);
    const count = words.length;
    setWordCount(count);

    const timeSpent = (TEST_DURATION - timeLeft) / 60;

    if (timeSpent > 0) {
      setWpm(Math.round(count / timeSpent));
    }
  }, [text, timeLeft]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  return (
    <div style={{ maxWidth: "900px", margin: "30px auto", fontFamily: "Arial" }}>
      
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h3>বাংলাদেশ ইস্পাত ও প্রকৌশল করপোরেশন</h3>
        <p>বিএসইসি ভবন</p>
        <hr />
      </div>

      {/* Candidate Info */}
      <div style={{ marginBottom: "20px" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          <input className="form-control" placeholder="নাম" />
          <input className="form-control" placeholder="পদবী" />
          <input className="form-control" placeholder="বিভাগ" />
        </div>
      </div>

      {/* Control Panel */}
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <button
          className="btn btn-success me-2"
          onClick={startTimer}
          disabled={isActive}
        >
          Start Test
        </button>

        {/* <button
          className="btn btn-danger"
          onClick={resetTest}
        >
          Reset
        </button> */}
      </div>

      {/* Timer */}
      <h4 style={{ textAlign: "center" }}>
        ⏱ Time Left: {formatTime(timeLeft)}
      </h4>

      {/* Typing Area */}
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={!isActive}
        placeholder="এখানে টাইপ শুরু করুন..."
        onPaste={(e) => e.preventDefault()}
        // onCopy={(e) => e.preventDefault()}
        onCut={(e) => e.preventDefault()}
        onDrop={(e) => e.preventDefault()}
        style={{
          width: "100%",
          height: "250px",
          padding: "15px",
          fontSize: "16px",
          border: "2px solid #ccc",
          borderRadius: "8px",
          marginTop: "10px",
        }}
      />

      {/* Result Panel */}
      <div
        style={{
          marginTop: "20px",
          padding: "15px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          background: "#f9f9f9",
        }}
      >
        <h5>📊 Result Summary</h5>
        <p>📝 Word Count: <strong>{wordCount}</strong></p>
        <p>⚡ WPM: <strong>{wpm}</strong></p>
      </div>

      {/* End Message */}
      {!isActive && timeLeft === 0 && (
        <h4 style={{ color: "red", textAlign: "center", marginTop: "15px" }}>
          ⛔ সময় শেষ! পরীক্ষা সম্পন্ন হয়েছে।
        </h4>
      )}
    </div>
  );
};

export default TypingTest;